'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  top: ', ';\n  right: ', ';\n  left: ', ';\n  border-top: ', ';\n  min-width: ', ';\n  position: absolute;\n  margin: 0;\n  padding: ', ' 0;\n  box-shadow: 0 1px 2px 2px ', ';\n  display: ', ';\n  background-color: ', '\n\n  &:hover {\n    display: block;\n  }\n'], ['\n  top: ', ';\n  right: ', ';\n  left: ', ';\n  border-top: ', ';\n  min-width: ', ';\n  position: absolute;\n  margin: 0;\n  padding: ', ' 0;\n  box-shadow: 0 1px 2px 2px ', ';\n  display: ', ';\n  background-color: ', '\n\n  &:hover {\n    display: block;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Ul = _styledComponents2.default.ul(_templateObject, function (_ref) {
  var top = _ref.top;
  return top || '0';
}, function (_ref2) {
  var right = _ref2.right;
  return right || 'auto';
}, function (_ref3) {
  var left = _ref3.left;
  return left || 'auto';
}, function (_ref4) {
  var bordered = _ref4.bordered,
      theme = _ref4.theme;
  return bordered ? 'solid 2px ' + theme.color.primary : 'none';
}, function (_ref5) {
  var minWidth = _ref5.minWidth;
  return minWidth;
}, (0, _polished.rem)(5), function (_ref6) {
  var theme = _ref6.theme;
  return theme.separatorColor;
}, function (_ref7) {
  var display = _ref7.display;
  return display ? 'block' : 'none';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.defaultBg || 'white';
});

function PopUpList(props) {
  var children = props.children;
  return _react2.default.createElement(Ul, {
    bordered: props.bordered,
    top: props.top,
    right: props.right,
    left: props.left,
    display: !!props.display,
    minWidth: props.minWidth
  }, children);
}

PopUpList.propTypes = {
  top: _propTypes2.default.string,
  right: _propTypes2.default.string,
  left: _propTypes2.default.string,
  bordered: _propTypes2.default.bool,
  display: _propTypes2.default.bool,
  minWidth: _propTypes2.default.string
};
PopUpList.defaultProps = {
  top: '0',
  right: 'auto',
  left: 'auto',
  bordered: false,
  display: false,
  minWidth: '80px'
};
exports.default = PopUpList;
PopUpList.__docgenInfo = [{
  'description': '',
  'displayName': 'PopUpList',
  'methods': [],
  'props': {
    'top': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'0\'',
        'computed': false
      }
    },
    'right': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'auto\'',
        'computed': false
      }
    },
    'left': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'auto\'',
        'computed': false
      }
    },
    'bordered': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'display': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'minWidth': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'80px\'',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/PopUpList/index.js'] = {
    name: 'PopUpList',
    docgenInfo: PopUpList.__docgenInfo,
    path: 'src/PopUpList/index.js'
  };
}